import * as actionTypes from '../actions/actionTypes';

export default function (state = null, action) {
  switch (action.type) {
    case actionTypes.FETCH_DOCUMENTS_REQUIRED_SUCCESS:
      return action.documentsRequired;
    default:
      return state;
  }
}
